import { Component } from '@angular/core';

@Component({
    selector: 'app-sales-objectives-rule-create',
    templateUrl: './sales-objectives-rule-create.component.html',
    styleUrl: './sales-objectives-rule-create.component.scss',
    standalone: false
})
export class SalesObjectivesRuleCreateComponent {

}
